import { IsNotEmpty, IsString, Length } from "class-validator";

export class CreateBoxInterfaceDTO {

    @IsNotEmpty()
    @Length(1, 50)
    @IsString()
    name!: string;

    @IsNotEmpty()
    @Length(1, 255)
    @IsString()
    description!: string;

}

